import { useMemo, useRef, useState } from "react";
import { Eye, Save, Trash2, Upload, Mail } from "lucide-react";
import { toast } from "react-toastify";
import styles from "./emailtemplate.module.css";
import { useEmailTemplate } from "../../actions/EmailTemplate";
// import EmailTemplateList from "./EmailTemplateList";

export default function EmailTemplateBuilder() {
   const { GetEmailTemplates, crearEmailTemplate, sendTestEmail } = useEmailTemplate();
   const templates = GetEmailTemplates();
   const editorRef = useRef(null);
   const [name, setName] = useState("");
   const [logo, setLogo] = useState(null);
   const [richHtml, setRichHtml] = useState("");
   const [showPreview, setShowPreview] = useState(true);

   const [input, setInput] = useState({
      id: 0,
      titulo: "",
   });
   
   function handleChange(e) {
      e.preventDefault();
      const { name, value } = e.target;
      const selectedTemplate = (templates ?? []).find(
         (template) => template.id === parseInt(value, 10),
      );

      setInput({
         ...input,
         [name]: value,
      });
      setName(selectedTemplate?.titulo || "");
      setRichHtml(selectedTemplate?.html || "");
      if (editorRef.current) {
         editorRef.current.innerHTML = selectedTemplate?.html || "";
         editorRef.current.style.textAlign = "left";
      }
   }
   const emailHtml = useMemo(() => {
      return `
      <div style="margin:0;background:#f5f7fb;padding:30px 12px;font-family:Arial,Helvetica,sans-serif;">
      <div style="max-width:680px;margin:0 auto;background:#ffffff;border-radius:14px;overflow:hidden;border:1px solid #dfe4ef;">
      <div style="padding:26px;background:linear-gradient(135deg,#1f3a5f,#2d6ea6);text-align:center;">
      ${logo ? `<img src="${logo}" alt="header icon" style="max-width:88px;max-height:88px;object-fit:contain;border-radius:12px;background:#ffffff;padding:8px;" />` : "<div style='color:#e7f0ff;font-size:12px;letter-spacing:.08em;text-transform:uppercase;'>Your Icon</div>"}
      </div>
      <div style="padding:28px;color:#192130;line-height:1.6;">${richHtml || "<p style='font-size:16px;margin:0;'>Start writing your professional email template.</p>"}</div>
      </div>
      </div>
      `;
   }, [logo, richHtml]);
   
   const handleLogoUpload = (event) => {
      const file = event.target.files?.[0];
      if (!file) {
         return;
      }
      if (!file.type.startsWith("image/")) {
         toast.error("Please upload an image file.");
         return;
      }
      
      const reader = new FileReader();
      reader.onloadend = () => {
         setLogo(reader.result);
         toast.success("Icon uploaded.");
      };
      reader.readAsDataURL(file);
   };
   
   const applyFormat = (command, value = null) => {
      if (!editorRef.current) {
         return;
      }
      editorRef.current.focus();
      console.log('editorRef: ', editorRef);
      document.execCommand(command, false, value);
      setRichHtml(editorRef.current.innerHTML);
   };
   
   const clearEditor = () => {
      if (editorRef.current) {
         editorRef.current.innerHTML = "";
         editorRef.current.style.textAlign = "left";
      }
      setRichHtml("");
      toast.info("Editor content cleared.");
   };
   
   const saveTemplateLocal = async () => {
      if (!name.trim()) {
         toast.error("Please enter a template name.");
         return;
      }
      
      const payload = {
         id: input.id,
         titulo: name,
         logo,
         html: richHtml,
         raw_html: emailHtml,
         createdAt: new Date().toISOString(),
      };
      console.log("handleSubmit: ", payload);
      await crearEmailTemplate.mutateAsync(payload);
      // window.location.href = "/EmailTemplate";
      // navigate("/EmailTemplate");
      
      const current = JSON.parse(
         localStorage.getItem("emailTemplates") || "[]",
      );
      localStorage.setItem(
         "emailTemplates",
         JSON.stringify([payload, ...current]),
      );
      toast.success("Template saved in local storage.");
   };

   const sendEmailTest = async () => {
      if (!richHtml.trim()) {
         toast.error("Please add content to the email before sending.");
         return;
      }

      const emailPayload = {
         email: "robindmercer@gmail.com",
         asunto: name || "Email Template Test",
         texto: emailHtml,
      };

      try {
         await sendTestEmail.mutateAsync(emailPayload);
      } catch (error) {
         console.error("Error sending test email:", error);
      }
   };
   
   console.log("templates: ", templates);
   console.log('input: ', input);
   return (
      <>
         <div className={styles.templateBuilder}>
            <div className={styles.builderContainer}>
               <div
                  style={{
                     display: "flex",
                     alignItems: "center",
                     marginBottom: "1.5rem",
                     backgroundColor: "#f9fafb",
                     padding: "1rem",
                     borderRadius: "8px",
                  }}
                  >
                  <div className="">
                     <p>Saved Templates</p>
                  </div>
                  <div>
                     <select
                        name="id"
                        id="id"
                        onChange={(e) => handleChange(e)}
                        value={input.id}
                     >
                        <option value="0">Seleccionar</option>

                        {(templates ?? []).map((t) => {
                           return <option value={t.id}>{t.titulo}</option>;
                        })}
                     </select>
                  </div>
               </div>
               <h1 className={styles.mainTitle}>
                  Email Template Builder
               </h1>

               <div className={styles.builderSection}>
                  <div className={styles.formGroup}>
                     <label className={styles.label}>Template Name</label>
                     <input
                        type="text"
                        className={styles.input}
                        placeholder="Ex: Welcome Campaign April"
                        value={name}
                        onChange={(event) => setName(event.target.value)}
                     />
                  </div>

                  <div className={styles.formGroup}>
                     <label className={styles.label}>Header Icon</label>
                     <div className={styles.iconUploadArea}>
                        <input
                           id="email-logo-upload"
                           className={styles.fileInput}
                           type="file"
                           accept="image/*"
                           onChange={handleLogoUpload}
                        />
                        <label
                           htmlFor="email-logo-upload"
                           className={styles.uploadLabel}
                        >
                           {logo ? (
                              <div className={styles.iconPreview}>
                                 <img src={logo} alt="Header icon preview" />
                                 <p>Click to replace icon</p>
                              </div>
                           ) : (
                              <div className={styles.uploadPlaceholder}>
                                 <p>
                                    <Upload size={18} /> Upload icon
                                 </p>
                                 <small>PNG, JPG, SVG</small>
                              </div>
                           )}
                        </label>
                     </div>
                  </div>

                  <div className={styles.formGroup}>
                     <label className={styles.label}>Editor Toolbar</label>
                     <div className={styles.toolbar}>
                        <button
                           type="button"
                           className={styles.toolBtn}
                           onClick={() => applyFormat("formatBlock", "<h1>")}
                        >
                           H1
                        </button>
                        <button
                           type="button"
                           className={styles.toolBtn}
                           onClick={() => applyFormat("formatBlock", "<h2>")}
                        >
                           H2
                        </button>
                        <button
                           type="button"
                           className={styles.toolBtn}
                           onClick={() => applyFormat("formatBlock", "<p>")}
                        >
                           Body
                        </button>
                        <button
                           type="button"
                           className={styles.toolBtn}
                           onClick={() => applyFormat("fontSize", "2")}
                        >
                           Small
                        </button>
                        <button
                           type="button"
                           className={styles.toolBtn}
                           onClick={() => applyFormat("fontSize", "4")}
                        >
                           Large
                        </button>
                        <button
                           type="button"
                           className={styles.toolBtn}
                           onClick={() => applyFormat("insertUnorderedList")}
                        >
                           List
                        </button>
                        <span style={{ width: "1px", backgroundColor: "#ccc", margin: "0 8px" }} />
                        <button
                           type="button"
                           className={styles.toolBtn}
                           onClick={() => applyFormat("justifyLeft")}
                        >
                           Izquierda
                        </button>
                        <button
                           type="button"
                           className={styles.toolBtn}
                           onClick={() => applyFormat("justifyCenter")}
                        >
                           Centrar
                        </button>
                        <button
                           type="button"
                           className={styles.toolBtn}
                           onClick={() => applyFormat("justifyRight")}
                        >
                           Derecha
                        </button>
                        <span style={{ width: "1px", backgroundColor: "#ccc", margin: "0 8px" }} />
                        <button
                           type="button"
                           className={styles.toolBtn}
                           onClick={() => applyFormat("bold")}
                        >
                           Bold
                        </button>
                        <button
                           type="button"
                           className={styles.toolBtn}
                           onClick={() => applyFormat("italic")}
                        >
                           Italic
                        </button>
                        <button
                           type="button"
                           className={styles.toolBtn}
                           onClick={() => applyFormat("underline")}
                        >
                           Underline
                        </button>
                     </div>

                     <div
                        ref={editorRef}
                        className={styles.richEditor}
                        contentEditable
                        suppressContentEditableWarning
                        onInput={(event) =>
                           setRichHtml(event.currentTarget.innerHTML)
                        }
                        data-placeholder="Write your professional email content here..."
                     />
                     <p className={styles.editorHint}>
                        Tip: Use H1/H2 for titles and Body/Small for paragraphs
                        to create clear hierarchy.
                     </p>
                  </div>

                  <div className={styles.buttonGroup}>
                     <button
                        type="button"
                        className={styles.previewBtn}
                        onClick={() => setShowPreview((prev) => !prev)}
                     >
                        <Eye size={18} />{" "}
                        {showPreview ? "Hide Preview" : "Show Preview"}
                     </button>
                     <button
                        type="button"
                        className={styles.saveBtn}
                        onClick={saveTemplateLocal}
                     >
                        <Save size={18} /> Save Template
                     </button>
                     <button
                        type="button"
                        className={styles.saveBtn}
                        onClick={sendEmailTest}
                     >
                        <Mail size={18} /> Send Test Email
                     </button>
                     <button
                        type="button"
                        className={styles.resetBtn}
                        onClick={clearEditor}
                     >
                        <Trash2 size={18} /> Clear Content
                     </button>
                  </div>
               </div>

               {showPreview && (
                  <div className={styles.previewSection}>
                     <h2 className={styles.previewTitle}>Email Preview</h2>
                     <div
                        className={styles.emailPreview}
                        dangerouslySetInnerHTML={{ __html: emailHtml }}
                     />
                  </div>
               )}
            </div>
         </div>
      </>
   );
}
